import React, {useEffect, useRef, useState} from 'react';
import s from './WordsCount.module.css';
import {highlightHashtags, highlightSearchTerm} from "../../../../shared/utils/highlightText";
import ReactQuill from "react-quill";

interface WordCountProps {
    value: string;
    quillRef: React.MutableRefObject<ReactQuill | null>;

}

const WordCount: React.FC<WordCountProps> = ({ value,quillRef }) => {

    const [wordCount, setWordCount] = useState<number>(0);
    const [searchTerm, setSearchTerm] = useState<string>("");

    useEffect(() => {
        const editor = quillRef.current?.getEditor();
        if (editor) highlightSearchTerm(editor, searchTerm);
    }, [searchTerm]);


    useEffect(() => {
        const editor = quillRef.current?.getEditor();
        if (editor) {
            const plainText = editor.getText().trim();
            const words = plainText.split(/\s+/).filter(word => word.length > 0);
            setWordCount(words.length);


            highlightHashtags(editor);
        }
    }, [value]);
    return (
        <div className={s.wrapper}>
            <p className={s.text}>{wordCount} words</p>
            <input
                placeholder="Find a word"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={s.input}
            />
        </div>
    );
};

export default WordCount;
